/**
 * Centralized API endpoints for Big Sports
 * Base URL is read once from NEXT_PUBLIC_API_BASE_URL (set in .env files)
 */

const rawBaseBuild = process.env.NEXT_PUBLIC_API_BASE_URL ?? "";

function normalizeBase(raw: string) {
  return raw
    .trim()
    .replace(/^['"]|["']$/g, "")
    .replace(/\/+$/, "");
}

const BASE_URL = rawBaseBuild ? normalizeBase(rawBaseBuild) : "";

// If runtime has an injected value (e.g., window.__ENV__ or global var), prefer that
// if (!BASE_URL && typeof window !== "undefined") {
//   const win = window as any;
//   const runtimeCandidates = [
//     win.__NEXT_PUBLIC_API_BASE_URL,
//     win.__ENV?.NEXT_PUBLIC_API_BASE_URL,
//     win.NEXT_PUBLIC_API_BASE_URL,
//   ];
//   for (const cand of runtimeCandidates) {
//     if (cand) {
//       BASE_URL = normalizeBase(String(cand));
//       break;
//     }
//   }
// }

// Do NOT fallback to window.location.origin here — APIs are hosted elsewhere and must be provided by server env
// if (!BASE_URL) {
//   throw new Error(
//     "NEXT_PUBLIC_API_BASE_URL is not set. Define it in your server .env (build-time) or inject it into the page as window.__NEXT_PUBLIC_API_BASE_URL.",
//   );
// }

// If an origin-like host was provided without scheme and we're on the server, assume https
// if (
//   BASE_URL &&
//   !/^https?:\/\//i.test(BASE_URL) &&
//   typeof window === "undefined"
// ) {
//   BASE_URL = `https://${BASE_URL}`;
// }

// console.log("Resolved BASE_URL:", BASE_URL);

export const endpoints = {
  /** Get available fields for a given date */
  fields: (date: string) =>
    `${BASE_URL}/api/fields?date=${encodeURIComponent(date)}`,

  /** Get available slots for a field on a date */
  slots: (date: string, fieldId: string | number) =>
    `${BASE_URL}/api/slots?date=${encodeURIComponent(date)}&fieldId=${fieldId}`,

  /** Get pricing for a time range on a field */
  pricing: (fieldId: string | number, from: string, to: string) =>
    `${BASE_URL}/api/pricing?fieldId=${fieldId}&from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,

  /** Create a new reservation */
  reservations: () => `${BASE_URL}/api/reservations`,

  /** Create full payment for a reservation */
  paymentsCreate: () => `${BASE_URL}/api/payments/create`,

  /** Create advance/partial payment for a reservation */
  paymentsCreateAdvance: () => `${BASE_URL}/api/payments/create-advance`,

  /** Get payment details for a reservation using access token */
  paymentsDetails: (reservationId: number, accessToken: string) =>
    `${BASE_URL}/api/payments/details/${reservationId}?accessToken=${encodeURIComponent(accessToken)}`,

  /** Trigger post-payment confirmation flow */
  paymentsTriggerConfirmation: () =>
    `${BASE_URL}/api/payments/trigger-confirmation`,
} as const;

export type EndpointKey = keyof typeof endpoints;
